/**
 * Admin > Reports > User-wise + Algo-wise Monthly P&L Report (V1). Mirrors
 * backend `app.schemas.algo_pnl_report.*` / `app.api.v1.admin_algo_pnl_report`
 * field-for-field. Both endpoints are ADMIN-role gated on the backend --
 * identical role-gating to every other Admin page (see `analyticsService`).
 *
 * All aggregation (sums, win/loss counts, win rate, monthly + overall
 * totals) happens on the backend -- this service never re-derives a total
 * from `rows` itself, matching the spec's "don't load all trades into the
 * frontend just to calculate totals" requirement.
 */
import api from "@/services/api";
import type {
  AlgoPnlReportFilterOptionsResponse,
  AlgoPnlReportResponse,
} from "@/types";

export interface AlgoPnlReportParams {
  user_id?: string;
  algo_id?: string;
  start_date?: string; // ISO date (YYYY-MM-DD), IST calendar date, inclusive
  end_date?: string; // ISO date (YYYY-MM-DD), IST calendar date, inclusive
}

export const algoPnlReportService = {
  getReport: async (params: AlgoPnlReportParams = {}): Promise<AlgoPnlReportResponse> => {
    const { data } = await api.get<AlgoPnlReportResponse>("/admin/reports/algo-pnl", { params });
    return data;
  },
  getFilterOptions: async (): Promise<AlgoPnlReportFilterOptionsResponse> => {
    const { data } = await api.get<AlgoPnlReportFilterOptionsResponse>("/admin/reports/algo-pnl/filters");
    return data;
  },
};

export default algoPnlReportService;
